import { render, staticRenderFns } from "./HomePopularWines.vue?vue&type=template&id=700729f8&scoped=true"
import script from "./HomePopularWines.vue?vue&type=script&lang=js"
export * from "./HomePopularWines.vue?vue&type=script&lang=js"
import style0 from "./HomePopularWines.vue?vue&type=style&index=0&id=700729f8&prod&scoped=true&lang=css"
import style1 from "./HomePopularWines.vue?vue&type=style&index=1&id=700729f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700729f8",
  null
  
)

export default component.exports